(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/payout-table.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/payout-table.js');
'use strict';

svs.numbergames.results.views.PayoutTable = Marionette.View.extend({
  className: 'ng-payout-bg grid-row gutter-xs-2 gutter-am-0',
  template(data) {
    return svs.numbergames.results.templates.payout_table(data);
  }
});

 })(window);